import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/weixin': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M385.2 167.6c-92.4 0-165.4 69.1-165.3 154 0 14.2 2.2 27.9 6.2 40.8-6.2 0.5-12.1 0.8-18.3 0.8-24.4 0-43.8-4.9-68.2-9.7l-68 34.1 19.3-58.6c-48.6-34.1-77.9-78.2-77.9-131.6 0-92.6 87.5-165.4 194.7-165.4 95.6 0 179.7 58.3 196.3 136.7-6.2-0.8-12.4-1.1-18.8-1.1zM280.7 114.7c-14.7 0-29.2 9.7-29.3 24.4 0 14.5 14.5 24.2 29.3 24.2 14.5 0 24.2-9.7 24.2-24.2 0-14.7-9.7-24.4-24.2-24.4zM144.3 163.3c14.8 0 24.4-9.6 24.4-24.2 0-14.7-9.6-24.4-24.4-24.4-14.5 0-29.3 9.6-29.3 24.4 0 14.5 14.8 24.2 29.3 24.2zM563 319.4c0 43.8-29 82.7-68.2 112.1l14.8 48.6-53.4-29.3c-19.7 4.8-39.3 9.9-58.6 9.9-92.6 0-165.4-63.4-165.4-141.3 0-77.9 72.7-141.3 165.4-141.3 87.5 0 165.4 63.4 165.4 141.3zM343.9 294.9c14.7 0 24.4-9.6 24.4-19.6 0-9.6-9.6-19.3-24.4-19.3-9.6 0-19.3 9.6-19.3 19.3 0 9.9 9.6 19.6 19.3 19.6zM451 294.9c14.5 0 24.5-9.6 24.4-19.6 0-9.6-9.9-19.3-24.4-19.3-9.6 0-19.3 9.6-19.3 19.3 0 9.9 9.6 19.6 19.3 19.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/weixin.js
// module id = 1090
// module chunks = 0